import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const PHONE = '919700022333';
const MESSAGE = 'Namaste! I would like to inquire about astrology consultation services at Amrutha Kalasam.';

const WhatsAppButton: React.FC = () => (
  <Tooltip title="Chat on WhatsApp" placement="left">
    <Fab
      component="a"
      href={`https://wa.me/${PHONE}?text=${encodeURIComponent(MESSAGE)}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat on WhatsApp"
      sx={{
        position: 'fixed',
        bottom: { xs: 20, md: 32 },
        right: { xs: 16, md: 28 },
        zIndex: 1300,
        width: { xs: 52, md: 60 },
        height: { xs: 52, md: 60 },
        bgcolor: '#25D366',
        color: '#fff',
        boxShadow: '0 4px 14px rgba(37,211,102,0.4)',
        '&:hover': { bgcolor: '#1DA851' },
      }}
    >
      <WhatsAppIcon sx={{ fontSize: { xs: 28, md: 32 } }} />
    </Fab>
  </Tooltip>
);

export default WhatsAppButton;
